export default __webpack_public_path__ + "static/media/appView.d4747a4c.png";